module.exports = __webpack_public_path__ + "img/logo_kontan.c873d499.png";